import { BaseChartAPIProps } from '~/types/create.types';

import { reDraw } from '../create/recalculate/recalculate';
import { drawCrosshair } from '../crosshair/crosshair';

export const onMouseMove = (
  event: MouseEvent & { shouldRedraw?: boolean },
  base: BaseChartAPIProps
) => {
  if (base.seriesType !== 'line') {
    return;
  }

  const index = Math.round(base.x.xScale.invert(event.offsetX));
  const isWithinBounds = index <= base.lastDataIdx && index >= 0;
  if (!isWithinBounds) {
    return;
  }

  if (onMouseMove.shouldRedraw) {
    reDraw(base);
  }

  const value = base.data[index].value;
  const time = base.data[index].time;

  drawCrosshair({
    ...base,
    hoveredPoint: { value, time, index },
  });
  onMouseMove.shouldRedraw = true;
};

onMouseMove.shouldRedraw = false;
